import { lazy, StrictMode, Suspense } from "react";
import ReactDOM from "react-dom/client";

import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "./Contexts/ThemeContext";
import { Loader } from "./components/Loader/Loader";
import ProtectedRoute from "./pages/ProtectedRoute";
import AdmJobPage from "./pages/admin/pages/AdmJobPage";
// Импортируем компоненты страниц
const Public = lazy(() => import("./public/pages/Public"));
const Performers = lazy(() => import("./public/pages/Performers"));
const Uslugi = lazy(() => import("./public/pages/Uslugi"));
const About = lazy(() => import("./public/pages/About"));
const Zadaniya = lazy(() => import("./public/pages/Zadaniya"));
const TopExecutors = lazy(() => import("./public/pages/TopExecutors"));
const Usluga = lazy(() => import("./public/pages/Usluga"));
const Task = lazy(() => import("./public/pages/Task"));
const NewJobs = lazy(() => import("./pages/NewJobs"));
const WorkJobs = lazy(() => import("./pages/WorkJobs"));
const WaitJobs = lazy(() => import("./pages/WaitJobs"));
const CloseJobs = lazy(() => import("./pages/CloseJobs"));
const Profile = lazy(() => import("./pages/account/Profile"));
const CharacterChange = lazy(() => import("./pages/account/CharacterChange"));
const PublicProfilePage = lazy(() => import("./pages/PublicProfilePage"));
const Login = lazy(() => import("./pages/account/LoginPage"));
const NotififcationPage = lazy(() => import("./pages/NotififcationPage"));
const AdminMain = lazy(() => import("./pages/admin/AdminMain"));
// const OrdersPage = lazy(() => import("./pages/client/OrdersPage"));
// const CreatePage = lazy(() => import("./pages/client/CreatePage"));
// const ProfileClient = lazy(() => import("./pages/client/ProfileClient"));
// const OrderPage = lazy(() => import("./pages/client/OrderPage"));
const BlogPage = lazy(() => import("./public/pages/Blog"));
const InfoPage = lazy(() => import("./public/pages/Info"));
const AdmExecutorPage = lazy(
  () => import("./pages/admin/pages/AdmExecutorPage")
);
const DashListPage = lazy(() => import("./pages/admin/dashs/DashListPage"));
const DashAdd = lazy(() => import("./pages/admin/dashs/DashAdd"));
const App = () => {
  return (
    <BrowserRouter>
      <Suspense fallback={<Loader isLoading isPage></Loader>}>

        <ThemeProvider>
          <HelmetProvider>
            <Routes>
              <Route path="/" element={<Public />} />
              <Route path="/ispolniteli" element={<Performers />} />
              <Route path="/ispolniteli/zadaniya/" element={<Zadaniya />} />
              <Route path="/ispolniteli/top/" element={<TopExecutors />} />
              <Route path="/about/" element={<About />} />
              <Route path="/uslugi" element={<Uslugi />} />
              <Route path="/uslugi/:url/" element={<Usluga />} />
              <Route path="/ispolniteli/zadaniya/:url/" element={<Task />} />

              <Route element={<ProtectedRoute />}>
                <Route path="/find" element={<NewJobs></NewJobs>} />
                <Route path="/work" element={<WorkJobs />} />
                <Route path="/wait" element={<WaitJobs />} />
                <Route path="/close" element={<CloseJobs />} />
                <Route path="/notifications" element={<NotififcationPage />} />
                {/* <Route path="/client/" element={<OrdersPage />} />
            <Route path="/client/create/" element={<CreatePage />} />
            <Route path="/client/order/:id/" element={<OrderPage />} />
            <Route path="/client/profile/" element={<ProfileClient />} /> */}
                <Route path="/authorize/user/" element={<Profile />} />
                <Route path="/authorize/transfer/:shared_user_id/" element={<CharacterChange />} />
                <Route path="/admin/" element={<AdminMain />} />
                <Route
                  path="/admin/executor/:id/"
                  element={<AdmExecutorPage />}
                />
                <Route path="/admin/job/:id/" element={<AdmJobPage />} />
                <Route path="/admin/dashs/" element={<DashListPage />} />
                <Route path="/admin/dashs/:id/" element={<DashAdd />} />
              </Route>
              <Route
                path="/authorize/user/:user_id/"
                element={<PublicProfilePage />}
              />
              <Route path="/authorize/" element={<Profile />} />
              <Route path="/authorize/auth" element={<Login />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:url/" element={<InfoPage />} />
              <Route path="/documents/:url/" element={<InfoPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </HelmetProvider>
        </ThemeProvider>
      </Suspense>
    </BrowserRouter>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
